import * as types from '../type'
import { setStore, getStore, clearStore, merge } from 'service/utils'

const state = {
    userLog : {},
    cancelTokenArr: [],
    pageFixed: false,
    roleStatus: 1, // 1 完成 0 未完成
    messageCount: 0
}

const getters = {
    version: state => {
        return getStore('version') || null
    },
    pageFixed: state => {
        return state.pageFixed
    },
    roleStatus: state => {
        return state.roleStatus
    },
    userLog: state => {
        if(state.userLog && state.userLog.log){
            return state.userLog
        }
        return getStore('userLog') || {}
    },
    messageCount: (state,getters,rootState,rootGetters) =>{
        return state.messageCount || ((rootGetters['auth/user']).unread_message || 0)
    }
}

const actions = {

    exit({commit}){
        commit(types.EXIT)
    },

    set_userLog({commit}, data){
        commit(types.SETUSERLOG, data)
    },

    set_pageState({commit}, data){
        commit(types.SETPAGESTATE, data)
    },
    set_roleStatus({commit}, data){
        commit(types.ROLESTATUS, data)
    },
    set_roleMessageCount({commit}, count){
        commit(types.ROLEMESSAGECOUNT, count)
    },
    set_roleMessageCountDecrease({commit,dispatch}, count){
        let user = getStore('user')
        let { unread_message, thisUserMess,workers_position_list } = user
        let { job_id } = thisUserMess
        commit(types.ROLEMESSAGEDECREASE, count)
        let workers_position = workers_position_list.map(item=>{
            if (item.id == job_id) {
                item.unread_message = count ? (unread_message >=count ?   unread_message - count : 0) : 0
            }
            return item
        })
        dispatch(`auth/set_user`, {
            ...user,
            unread_message: count ? (unread_message >=count ?   unread_message - count : 0) : 0,
            workers_position_list: workers_position
        }, {root: true}) 
    },
    set_roleMessageCountIncrease({commit,dispatch}, count){
        let user = getStore('user')
        let { unread_message,thisUserMess,workers_position_list } = user
        let { job_id } = thisUserMess
        /* 跟新当前模块消息数量 */
        commit(types.ROLEMESSAGEINCREASE, count)
        /* 更新auth模块user信息 */
        let workers_position = workers_position_list.map(item=>{
            if (item.id == job_id) {
                item.unread_message = unread_message + count
            }
            return item
        })
        dispatch(`auth/set_user`, {
            ...user,
            unread_message: unread_message + count,
            workers_position_list: workers_position
        }, {root: true}) 
    }
}
const mutations = {

    [types.EXIT](state){
        state.user = ''
        clearStore()
    },

    [types.SETUSERLOG](state, data){
        setStore('userLog', data)
        state.userLog = merge({}, data)
    },

    [types.PUSHHTTP] (state, data) {
        state.cancelTokenArr.push(data.cancelToken)
    },
    [types.SETPAGESTATE] (state, data) {
        state.pageFixed = data
    },
    [types.ROLESTATUS] (state, data) {
        state.roleStatus = data
    },

    [types.CLEARHTTP] ({ cancelTokenArr }) {
        cancelTokenArr.forEach(item => {
            if(item) item('路由跳转取消请求')
        })
        cancelTokenArr = []
    },
    [types.ROLEMESSAGEDECREASE](state,count){
        if (state.messageCount >= count) {
            state.messageCount = state.messageCount - count
        } else {
            state.messageCount = 0
        }
    },
    [types.ROLEMESSAGEINCREASE](state,count){
        state.messageCount = state.messageCount + count
    },
    [types.ROLEMESSAGECOUNT](state,count){
        state.messageCount = count
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js